module.exports = __webpack_public_path__ + "static/img/39.efb9460.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rz/39.jpg
// module id = Y51t
// module chunks = 0